/**
 * Reusable "treatment approach" blurbs surfaced on programmatic pages.
 * Lets templated pages explain HOW physiotherapists treat conditions
 * without copy-pasting the same paragraph into every problem/service.
 */

export interface TreatmentApproach {
  name: string;
  /** ~1 paragraph. */
  description: string;
}

export const TREATMENT_APPROACHES: TreatmentApproach[] = [
  {
    name: 'Manual Therapy',
    description:
      'Hands-on techniques including joint mobilisation, soft tissue massage, myofascial release and trigger point therapy. Used to reduce pain, restore movement and break down adhesions in muscles and connective tissue.',
  },
  {
    name: 'Exercise Therapy',
    description:
      'The cornerstone of modern physiotherapy. Progressive, individualised exercises restore strength, mobility and motor control - the only intervention proven to produce long-term changes in tissue and function.',
  },
  {
    name: 'Dry Needling',
    description:
      'Fine needles inserted into trigger points to release tight muscle bands. Effective for chronic muscle tension, headaches, and stubborn pain that doesn\'t respond to massage alone. Different from acupuncture in approach and goal.',
  },
  {
    name: 'Electrotherapy',
    description:
      'Modalities like TENS, ultrasound, IFT and laser used to reduce pain and inflammation, especially in the early stages of injury. Always combined with exercise - never used as a standalone treatment.',
  },
  {
    name: 'Posture and Ergonomic Correction',
    description:
      'Workplace assessment and corrective programs targeting the desk-job posture problems epidemic in NCR - forward head, rounded shoulders, slouched lower back. Combines stretching, strengthening and habit retraining.',
  },
  {
    name: 'Taping and Bracing',
    description:
      'Kinesiology tape and rigid bracing support healing tissues, offload painful joints, and provide proprioceptive feedback. Especially useful in sports injuries and during return-to-activity phases.',
  },
];
